import React from 'react';
import { useSelector } from 'react-redux';
import { getData } from '../selectors';
import { SkeletonBlock } from '../../skeleton/components/Skeleton';

export const Total: React.FC<{ loading?: boolean }> = ({ loading }) => {
  const { total } = useSelector(getData);

  // Пока счётчика нет, держим его место плашкой: иначе строка над списком
  // «подпрыгивает» в момент, когда приходит total.
  if (loading) {
    return <SkeletonBlock className="al-skeleton-total" />;
  }

  return total ? (
    <div className="al-finder-assets-total">
      Showing {total.read.count} {total.read.count === 1 ? 'result' : 'results'}
    </div>
  ) : null;
};
